import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormEditorActionTypes } from "../../action-types/form/IFormEditorActionTypes";
import { IFoCaAnActionTypes } from "../../action-types/thuc-don/IFoCaAnActionTypes";
import { IFoCaAnReducer } from "../../page-state-model/thuc-don/IFoCaAnReducer";
const iniState: IFoCaAnReducer = {
    status: ePageBaseStatus.is_not_initialization,
    foCaAns: []
}
export const foCaAnReducer = (state: IFoCaAnReducer = iniState, action: IFoCaAnActionTypes): IFoCaAnReducer => {
    switch (action.type) {
        case "CA_AN_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CA_AN_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAns: action.payload
            }
        case "CA_AN_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAns: []
            }
        case "CA_AN_LOAD_COSO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CA_AN_LOAD_COSO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAns: action.payload
            }
        case "CA_AN_LOAD_COSO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                foCaAns: []
            }
        case "CA_AN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "CA_AN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CA_AN_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "CA_AN_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "CA_AN_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CA_AN_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "CA_AN_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CA_AN_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}